/* 講習関連 データベース定義
*/

export class DbCourseManagement {
    // 講習ID
    public courseId: string;
    // 講習名
    public name: string;
    // 領域 必修,選必,選択
    public region: string;
    // 講師
    public teacher: string;
    // 期間
    public from: string;
    // 期間
    public to: string;
    // 定員
    public capacity: number | null;
    // 受講者数
    public participants: number;

    // 識別子
    public uid?: string;

    // 詳細一覧 TSV
    public detailsTsv: string;

    // メール送信フラグ
    public sendMailFlag: boolean;

    // コンストラクタ
    constructor(){
        this.courseId = "";
        this.name = "";
        this.region = "";
        this.teacher = "";
        this.from = "";
        this.to = "";
        this.capacity = null;
        this.participants = 0;
        this.uid = "";
        this.detailsTsv = "";
        this.sendMailFlag = false;
    }

    // コンバーター
    public static Converter = {
        toFirestore: function(src: any) {
            console.log("toFirestore", src);
            if (typeof(src.uid) === "undefined") {
                src.uid = "";
            }
            if (typeof(src.sendMailFlag) === "undefined") {
                src.sendMailFlag = false;
            }
            return {
                courseId: src.courseId,
                name: src.name,
                region: src.region,
                teacher: src.teacher,
                from: src.from,
                to: src.to,
                capacity: src.capacity,
                participants: src.participants,
                uid: src.uid,
                detailsTsv: src.detailsTsv,
                sendMailFlag: src.sendMailFlag
            }
        },
        fromFirestore: function(snapshot: any, options: any){
            const data = snapshot.data(options);
            const dst = new DbCourseManagement();
            dst.courseId = data.courseId;
            dst.name =  data.name
            dst.region = data.region;
            dst.teacher = data.teacher;
            dst.from = data.from;
            dst.to = data.to;
            dst.capacity = data.capacity;
            dst.participants = data.participants;
            dst.uid = data.uid;
            dst.detailsTsv = data.detailsTsv;
            dst.sendMailFlag = data.sendMailFlag !== undefined ? data.sendMailFlag : false;
            return dst;
        }
    }
}


export class DbCourseManagementDetails {
    //分科会番号
    public subcommitteeNumber: string;
    // 章ID
    public chapterID: string;
    // 講義名
    public lectureName: string;
    // 分類
    public classification: string;
    // 説明
    public description: string;
    // 動画ID
    public videoID: string;
    // 再生速度変更
    public playbackSpeedChange: string;
    // ミーティングURL
    public meetingURL: string;
    // 開始日時
    public from: string;
    // 終了日時
    public to: string;
    // 講義時間（分）
    public time: string;

    // コンストラクタ
    constructor(){
        // console.log("DbCourseManagementDetails");
        this.subcommitteeNumber = "";
        this.chapterID = "";
        this.lectureName = "";
        this.classification = "";
        this.description = "";
        this.videoID = "";
        this.playbackSpeedChange = "";
        this.meetingURL = "";
        this.from = "";
        this.to = "";
        this.time = "";
    }

    // コンバーター
    public static Converter = {
        toFirestore: function(src: any) {
            return {
                subcommitteeNumber: src.subcommitteeNumber,
                chapterID: src.chapterID,
                lectureName: src.lectureName,
                classification: src.classification,
                description: src.description,
                videoID: src.videoID,
                playbackSpeedChange: src.playbackSpeedChange,
                meetingURL: src.meetingURL,
                from: src.from,
                to: src.to,
                time: src.time
            }
        },
        fromFirestore: function(snapshot: any, options: any){
            const data = snapshot.data(options);
            const dst = new DbCourseManagementDetails();
            dst.subcommitteeNumber = data.subcommitteeNumber;
            dst.chapterID = data.chapterID;
            dst.lectureName = data.lectureName;
            dst.classification = data.classification;
            dst.description = data.description;
            dst.videoID = data.videoID;
            dst.playbackSpeedChange = data.playbackSpeedChange;
            dst.meetingURL = data.meetingURL;
            dst.from = data.from;
            dst.to = data.to;
            dst.time = data.time;
            return dst;
        }
    }
}

// 研修申込者データ
export class DbCourseManagementUsersExcelText {
    // 講習ID
    public courseId: string;
    // EXCEL コピペ内容
    public text: string;
    // TSV
    public tsv: string;

    // コンストラクタ
    constructor(){
        this.courseId = "";
        this.text = "";
        this.tsv = "";
    }

    // コンバーター
    public static Converter = {
        toFirestore: function(src: any) {
            return {
                courseId: src.courseId,
                text: src.text,
                tsv: src.tsv,
            }
        },
        fromFirestore: function(snapshot: any, options: any){
            const data = snapshot.data(options);
            const dst = new DbCourseManagementUsersExcelText();
            dst.courseId = data.courseId;
            dst.text =  data.text;
            dst.tsv =  data.tsv;
            return dst;
        }
    }
}